import { REVIEW_PEER_STATUS } from 'constants/ProjectConstants';
import { setEndOfTheDayTime } from 'constants/helper';

export const getDeadlineEODTimeStamp = (date) => {
  if (!date) return null;
  const dateObj = new Date(date);
  setEndOfTheDayTime(dateObj);
  return dateObj.getTime();
};

export const PEER_STATUS_COLOR = {
  [REVIEW_PEER_STATUS.ACCEPTED]: 'green',
  [REVIEW_PEER_STATUS.NOMINATED]: 'yellow',
  [REVIEW_PEER_STATUS.DECLINED]: 'red',
};

export const PEER_STATUS_TEXT = {
  [REVIEW_PEER_STATUS.ACCEPTED]: 'Accepted',
  [REVIEW_PEER_STATUS.NOMINATED]: 'Pending',
  [REVIEW_PEER_STATUS.DECLINED]: 'Rejected',
};
